export default "<span class=\"spinner-text\">{{vm.text}}</span>\n";